/**
 * RECUPERE LES CLIENTS STORE
 */
export const INIT_ADMIN_STORE_CUSTOMERS = "store/customers/INIT_ADMIN_STORE_CUSTOMERS";
export const INIT_ADMIN_STORE_CUSTOMERS_COMPLETED = "store/customers/INIT_ADMIN_STORE_CUSTOMERS_COMPLETED";
export const INIT_ADMIN_STORE_CUSTOMERS_FAILED = "store/customers/INIT_ADMIN_STORE_CUSTOMERS_FAILED";

/**
 * RECUPERE LES INFOS HORS COMMANDE DU CLIENT
 */
export const GET_STORE_CUSTOMER_INFO = "store/customers/GET_STORE_CUSTOMER_INFO";

/**
 * RECUPERE LE DETAIL D'UN SEUL CLIENT (sans charger toute la liste)
 */
export const GET_STORE_CUSTOMER_DETAIL = "store/customers/GET_STORE_CUSTOMER_DETAIL";
export const GET_STORE_CUSTOMER_DETAIL_COMPLETED = "store/customers/GET_STORE_CUSTOMER_DETAIL_COMPLETED";
export const GET_STORE_CUSTOMER_DETAIL_FAILED = "store/customers/GET_STORE_CUSTOMER_DETAIL_FAILED";

/**
 * RECUPERE LES COMMANDES D'UN CLIENT STORE
 */
export const GET_STORE_CUSTOMER_ORDERS = "store/customers/GET_STORE_CUSTOMER_ORDERS";
export const GET_STORE_CUSTOMER_ORDERS_COMPLETED = "store/customers/GET_STORE_CUSTOMER_ORDERS_COMPLETED";
export const GET_STORE_CUSTOMER_ORDERS_FAILED = "store/customers/GET_STORE_CUSTOMER_ORDERS_FAILED";

/**
 * RECUPERE L'HISTORIQUE DES TRANSACTIONS BANCAIRES D'UN CLIENT (PayGreen + Edenred)
 */
export const GET_STORE_CUSTOMER_TRANSACTIONS = "store/customers/GET_STORE_CUSTOMER_TRANSACTIONS";
export const GET_STORE_CUSTOMER_TRANSACTIONS_COMPLETED = "store/customers/GET_STORE_CUSTOMER_TRANSACTIONS_COMPLETED";
export const GET_STORE_CUSTOMER_TRANSACTIONS_FAILED = "store/customers/GET_STORE_CUSTOMER_TRANSACTIONS_FAILED";

/**
 * Met à jour les infos clients
 */
export const UPDATE_STORE_CUSTOMER = "store/customers/UPDATE_STORE_CUSTOMER";
export const UPDATE_STORE_CUSTOMER_COMPLETED = "store/customers/UPDATE_STORE_CUSTOMER_COMPLETED";
export const UPDATE_STORE_CUSTOMER_FAILED = "store/customers/UPDATE_STORE_CUSTOMER_FAILED";

/**
 * Ajoute un client
 */
export const POST_STORE_CUSTOMER = "store/customers/POST_STORE_CUSTOMER";
export const POST_STORE_CUSTOMER_COMPLETED = "store/customers/POST_STORE_CUSTOMER_COMPLETED";
export const POST_STORE_CUSTOMER_FAILED = "store/customers/POST_STORE_CUSTOMER_FAILED";

export const STORE_CUSTOMER_SEND_CODE_BY_SMS = "store/customers/STORE_CUSTOMER_SEND_CODE_BY_SMS";
export const STORE_CUSTOMER_SEND_CODE_BY_SMS_COMPLETED = "store/customers/STORE_CUSTOMER_SEND_CODE_BY_SMS_COMPLETED";
export const STORE_CUSTOMER_SEND_CODE_BY_SMS_FAILED = "store/customers/STORE_CUSTOMER_SEND_CODE_BY_SMS_FAILED";

/**
 * Rembourse un paiement d'une commande (PayGreen)
 */
export const REFUND_ORDER_PAYMENT = "store/customers/REFUND_ORDER_PAYMENT";
export const REFUND_ORDER_PAYMENT_COMPLETED = "store/customers/REFUND_ORDER_PAYMENT_COMPLETED";
export const REFUND_ORDER_PAYMENT_FAILED = "store/customers/REFUND_ORDER_PAYMENT_FAILED";

/**
 * Annule l'utilisation des avantages (cagnotte) d'une commande et re-crédite le client
 */
export const CANCEL_ORDER_ADVANTAGE = "store/customers/CANCEL_ORDER_ADVANTAGE";
export const CANCEL_ORDER_ADVANTAGE_COMPLETED = "store/customers/CANCEL_ORDER_ADVANTAGE_COMPLETED";
export const CANCEL_ORDER_ADVANTAGE_FAILED = "store/customers/CANCEL_ORDER_ADVANTAGE_FAILED";
export const STORE_CUSTOMER_PASSWORD_RESET_LINK = "store/customers/STORE_CUSTOMER_PASSWORD_RESET_LINK";
export const STORE_CUSTOMER_PASSWORD_RESET_LINK_COMPLETED = "store/customers/STORE_CUSTOMER_PASSWORD_RESET_LINK_COMPLETED";
export const STORE_CUSTOMER_PASSWORD_RESET_LINK_FAILED = "store/customers/STORE_CUSTOMER_PASSWORD_RESET_LINK_FAILED";
